import api from 'api/apiInstance';

export function usersNotificationsMarkAllAsSeenApi(path: string) {
  return {
    path,
    PATCH: () => api.patch(path),
  };
}
